import React from 'react'
import styles from '../../table.module.scss';


const DeleteButton = ({className, style, onClick, ...other}) => {
    return <button className={`${styles.remove_button} ${className ? className : ""}`} style={style} {...other} onClick={onClick}></button>
} 

export default DeleteButton;